export type P5Instrument = {
    code: string;
    name: string;
    type: string;
    target: string;
    linked_qst: string[];
    linked_procedures: string[];
    duration: string;
    opening_script: string;
    sections: {
        name: string;
        linked_qst: string[];
        questions: string[];
        follow_ups: string[];
        notes: string;
    }[];
    checklist_items: { item: string; verification: string; conformity: string }[];
    document_items: { item: string; document: string; period: string }[];
    content_md: string;
};

export type P5FormData = {
    instruments: P5Instrument[];
    sampling: { method: string; sample_size: string; limitations: string };
};

export function defaultP5FormData(): P5FormData {
    return {
        instruments: [],
        sampling: { method: "", sample_size: "", limitations: "" },
    };
}
